import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import {
  DELETE_PROVIDER,
  GET_ALL_PROVIDERS,
} from '../../../../graphql/Catalog/Providers/providers'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../Global/LayoutTable'
import ContentHeader from '../../../Layout/ContentHeader'

const Providers = () => {
  const [dataTable, setDataTable] = useState([])
  const [count, setCount] = useState(0)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })

  const { loading, error, data } = useQuery(GET_ALL_PROVIDERS, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      searchQuery: pagePagination.searchQuery,
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw error

      if (!data) throw new Error('No se encontraron datos')

      const { getAllProviders } = data

      const infoProviders = getAllProviders.rows.map((provider) => {
        return {
          id: provider.id,
          Código: provider.card_code || 'S/A',
          Nombre: provider.card_name,
          RFC: provider.rfc,
          Tipo: provider.typeSpanish,
          Email: provider.email || 'S/A',
          Teléfono: provider.phone || 'S/A',
        }
      })

      setDataTable(infoProviders)
      setCount(getAllProviders.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  return (
    <>
      <ContentHeader
        breadcrumb=""
        title="Proveedores"
        windowTitle="Proveedores"
        addNewButton
        addNewButtonText='Agregar proveedor'
      />
      <LayoutTable
        hideId
        data={dataTable}
        totalCount={count}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        title="Lista de Proveedores"
        gql={DELETE_PROVIDER}
        hideDetails
        hideAddNew
      />
    </>
  )
}

export default Providers
